module.exports = __webpack_public_path__ + "static/media/service3.f43adf58.png";